"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitialState = void 0;
const constant_1 = require("./constant");
exports.InitialState = {
    type: constant_1.ThemeType.Dark,
};
